<template>
  <div>
    <span class="filter-key">{{ displayName }}:</span>
    <span class="filter-value">{{ displayValue }}</span>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {
  getReportFieldFromValue,
} from '../../../../../services/dashboard/reportFieldService';

export default {
  props: {
    filter: {
      type: Object,
      validator: val => {
        const { key } = val;

        return key !== undefined;
      },
    },
  },
  computed: {
    ...mapState({
      allReportFields: state => state.dashboard.availableReportFields.allReportFields,
    }),
    displayName() {
      const { key } = this.filter;
      const dimension = getReportFieldFromValue(this.allReportFields, key);

      return (dimension && dimension.key) || key;
    },
    displayValue() {
      const { value } = this.filter;

      if (value === undefined || value === null) {
        return 'null';
      }

      if (!Array.isArray(value)) {
        return value;
      }

      const base = value[0] === null ? 'null' : value[0];
      const display = base && base.length > 15 ? `${base.substring(0, 11)}...` : base;

      return value.length > 1
        ? `(${value.length}) ${display}, ...`
        : display;
    },
  },
};
</script>
<style scoped>
.filter-key {
  font-weight: bold;
}

.filter-value {
  margin-left: 12px;
}
</style>
